import React from 'react';
import { iConfigColumn } from '../../../UITypes/types';
import iContactCompanyProduct from '../../../../types/contactCompany/iContactCompanyProduct';
import LinkBtnUrl from '../../../buttons/LinkBtnUrl';
import { handleNullException } from '../../../../services/UtilsService';
import FetchRelatedElements from '../../../../pages/purchases/list/FetchRelatedElements';
import { getPOItemConfig } from '../../../../services/PurchaseOrderItemService';
import { getDNItemConfig } from '../../../../services/DispatchNoteItemService';
import DotOperation from './dotOperation/DotOperation';
import { AVOID_PAGINATION_PER_PAGE } from '../../../constants/AsyncConstants';

export const getRows = ({
  data,
  columns,
  jobId,
}: {
  data: Array<iContactCompanyProduct>;
  columns: Array<iConfigColumn>;
  jobId: string;
}) => {
  return data.map((item: iContactCompanyProduct) => {
    const cells = columns.map((column: iConfigColumn) => {
      const { key, dataSource, type } = column;
      switch (type) {
        case 'text':
          return {
            key: handleNullException(item, key),
            content: handleNullException(item, key),
          };

        case 'link':
          return {
            key: handleNullException(item, key),
            content: (
              <LinkBtnUrl
                btnName={handleNullException(item, key)}
                url={`${column.urlPrefix}/${handleNullException(
                  item,
                  dataSource[0],
                )}`}
              />
            ),
          };
        case 'sum-POItem-qty':
          return {
            content: (
              <FetchRelatedElements
                fetchFn={() =>
                  getPOItemConfig({
                    // 'SalesOrder_salesOrderId.ContactCompany_customerId.id',
                    advancedFilter: `jobId:${jobId},PurchaseOrder_orderId.supplierId:${item.contactCompanyId}`,
                    currentPage: '1',
                    perPage: AVOID_PAGINATION_PER_PAGE,
                  })
                }
                renderType={'number-conversion'}
                connectElementType={'sum'}
                dataSource={dataSource}
                suffix={handleNullException(
                  item,
                  'product.measurement.shortName',
                )}
              />
            ),
          };
        case 'sum-POItem-receivedQty':
          return {
            content: (
              <FetchRelatedElements
                fetchFn={() =>
                  getPOItemConfig({
                    advancedFilter: `jobId:${jobId},PurchaseOrder_orderId.supplierId:${item.contactCompanyId}`,
                    currentPage: '1',
                    perPage: AVOID_PAGINATION_PER_PAGE,
                  })
                }
                renderType={'number'}
                connectElementType={'sum'}
                dataSource={dataSource}
                suffix={handleNullException(
                  item,
                  'product.measurement.shortName',
                )}
              />
            ),
          };
        case 'sum-DNItem-qty':
          return {
            content: (
              <FetchRelatedElements
                fetchFn={() =>
                  getDNItemConfig({
                    advancedFilter: `jobId:${jobId},DispatchNote_dispatchNoteId.customerId:${item.contactCompanyId}`,
                    currentPage: '1',
                    perPage: AVOID_PAGINATION_PER_PAGE,
                  })
                }
                renderType={'number'}
                connectElementType={'sum'}
                dataSource={dataSource}
                suffix={handleNullException(
                  item,
                  'product.measurement.shortName',
                )}
                extraTimes={Number(item.unitConversion) || 1}
              />
            ),
          };
        case 'operation':
          return {
            content: <DotOperation jobId={jobId} ccp={item} />,
          };

        default:
          return { content: '' };
      }
    });
    return { cells, testId: 'admin-purchaseOrder-row' };
  });
};
